import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type FeatureFlagsService from 'garaje/services/feature-flags';
import type StateService from 'garaje/services/state';
import { hasThreatIntelV2Access } from 'garaje/utils/threat-intel-access';

export default class CommunicationsAlertsRoute extends Route {
  @service declare router: RouterService;
  @service declare featureFlags: FeatureFlagsService;
  @service declare state: StateService;

  beforeModel(): void {
    if (!hasThreatIntelV2Access(this.featureFlags, this.state)) {
      void this.router.transitionTo('communications.message-log.new');
    }
  }
}
